import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import PrepaymentDetailsModal from "../resources/common/PrepaymentDetailsModal";

const EditInvoicePrePaymentButton = ({
  initialValue,
  addPrepaidAmount,
  addPrepaymentDetails,
  readOnly,
  currentNetAmount = 0,
}) => {
  const [prePaymentPopupOpen, setPrePaymentPopupOpen] = useState(false);

  return (
    <div>
      <IconButton
        aria-label="edit"
        onClick={() => setPrePaymentPopupOpen(true)}
        color="primary"
        size="small"
      >
        <EditIcon fontSize="small" />
      </IconButton>
      <PrepaymentDetailsModal
        open={prePaymentPopupOpen}
        onClose={() => setPrePaymentPopupOpen(false)}
        readOnly={readOnly}
        addPrepaidAmount={addPrepaidAmount}
        addPrepaymentDetails={addPrepaymentDetails}
        initialValue={initialValue}
        currentNetAmount={currentNetAmount}
      />
    </div>
  );
};

export default EditInvoicePrePaymentButton;
